import { ERRORS, LOADING, SET_DATA } from './types'

interface TwoFactorProps {
  required: boolean
}

interface DataProps {
  two_factor?: TwoFactorProps
  id?: number
  name?: string
  balance?: object
}

interface InitialStateProps {
  loading: boolean
  loaded: boolean
  failed: boolean
  data: DataProps
  hasToken: boolean | null
}

const initialState: InitialStateProps = {
  loading: false,
  loaded: false,
  failed: false,
  data: {},
  hasToken: null
}

export function userReducer(state = initialState, action: any) {
  switch (action.type) {
    case ERRORS:
    case LOADING:
    case SET_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}
